import { render, staticRenderFns } from "./Edition2024.vue?vue&type=template&id=775e21f9&"
import script from "./Edition2024.vue?vue&type=script&lang=js&"
export * from "./Edition2024.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports